import { render, staticRenderFns } from "./ProductExpiredSubscribe.vue?vue&type=template&id=11743856&scoped=true"
import script from "./ProductExpiredSubscribe.vue?vue&type=script&lang=js"
export * from "./ProductExpiredSubscribe.vue?vue&type=script&lang=js"
import style0 from "./ProductExpiredSubscribe.vue?vue&type=style&index=0&id=11743856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11743856",
  null
  
)

export default component.exports